import { createTheme } from 'react-schedule-view';

const data_mon = [
    {
        name: "Понеділок",
        events: [
            {
                startTime: 0,
                endTime: 0.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 1,
                endTime: 1.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 2,
                endTime: 2.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 3,
                endTime: 3.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 4,
                endTime: 4.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 5,
                endTime: 5.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 6,
                endTime: 6.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 7,
                endTime: 7.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 8,
                endTime: 8.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 9,
                endTime: 9.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 10,
                endTime: 10.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 11,
                endTime: 11.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 12,
                endTime: 12.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 13,
                endTime: 13.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 14,
                endTime: 14.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 15,
                endTime: 15.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 16,
                endTime: 16.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 17,
                endTime: 17.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 18,
                endTime: 18.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 19,
                endTime: 19.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 20,
                endTime: 20.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 21,
                endTime: 21.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 22,
                endTime: 22.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 23,
                endTime: 23.99,
                title: "Free slot",
                color: 'grey',
            },
        ],
    },
];

const data_tue = [
    {
        name: "Вівторок",
        events: [
            {
                startTime: 0,
                endTime: 0.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 1,
                endTime: 1.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 2,
                endTime: 2.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 3,
                endTime: 3.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 4,
                endTime: 4.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 5,
                endTime: 5.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 6,
                endTime: 6.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 7,
                endTime: 7.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 8,
                endTime: 8.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 9,
                endTime: 9.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 10,
                endTime: 10.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 11,
                endTime: 11.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 12,
                endTime: 12.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 13,
                endTime: 13.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 14,
                endTime: 14.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 15,
                endTime: 15.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 16,
                endTime: 16.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 17,
                endTime: 17.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 18,
                endTime: 18.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 19,
                endTime: 19.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 20,
                endTime: 20.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 21,
                endTime: 21.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 22,
                endTime: 22.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 23,
                endTime: 23.99,
                title: "Free slot",
                color: 'grey',
            },
        ],
    }
]

const data_wed = [
    {
        name: "Середа",
        events: [
             {
                startTime: 0,
                endTime: 0.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 1,
                endTime: 1.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 2,
                endTime: 2.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 3,
                endTime: 3.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 4,
                endTime: 4.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 5,
                endTime: 5.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 6,
                endTime: 6.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 7,
                endTime: 7.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 8,
                endTime: 8.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 9,
                endTime: 9.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 10,
                endTime: 10.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 11,
                endTime: 11.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 12,
                endTime: 12.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 13,
                endTime: 13.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 14,
                endTime: 14.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 15,
                endTime: 15.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 16,
                endTime: 16.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 17,
                endTime: 17.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 18,
                endTime: 18.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 19,
                endTime: 19.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 20,
                endTime: 20.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 21,
                endTime: 21.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 22,
                endTime: 22.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 23,
                endTime: 23.99,
                title: "Free slot",
                color: 'grey',
            },
        ],
    }
]

const data_thu = [
    {
        name: "Четвер",
        events: [
            {
                startTime: 0,
                endTime: 0.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 1,
                endTime: 1.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 2,
                endTime: 2.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 3,
                endTime: 3.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 4,
                endTime: 4.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 5,
                endTime: 5.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 6,
                endTime: 6.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 7,
                endTime: 7.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 8,
                endTime: 8.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 9,
                endTime: 9.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 10,
                endTime: 10.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 11,
                endTime: 11.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 12,
                endTime: 12.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 13,
                endTime: 13.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 14,
                endTime: 14.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 15,
                endTime: 15.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 16,
                endTime: 16.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 17,
                endTime: 17.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 18,
                endTime: 18.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 19,
                endTime: 19.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 20,
                endTime: 20.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 21,
                endTime: 21.99,
                title: "Dj MVurry",
                link: 'djmvurry'
            },
            {
                startTime: 22,
                endTime: 23.99,
                title: "BAKER",
                link: 'baker'
            },
        ],
    }
]

const data_fri = [
    {
        name: "П'ятниця",
        events: [
            {
                startTime: 0,
                endTime: 0.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 1,
                endTime: 1.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 2,
                endTime: 2.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 3,
                endTime: 3.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 4,
                endTime: 4.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 5,
                endTime: 5.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 6,
                endTime: 6.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 7,
                endTime: 7.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 8,
                endTime: 8.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 9,
                endTime: 9.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 10,
                endTime: 10.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 11,
                endTime: 11.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 12,
                endTime: 12.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 13,
                endTime: 13.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 14,
                endTime: 14.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 15,
                endTime: 15.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 16,
                endTime: 16.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 17,
                endTime: 17.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 18,
                endTime: 18.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 19,
                endTime: 20,
                title: "ENSARU",
                link: 'ensaru',
            },
            {
                startTime: 20,
                endTime: 21,
                title: "Dj Raiskiy",
                link: 'diraiskiy'
            },
            {
                startTime: 21,
                endTime: 21.99,
                title: "Alex Cool",
                link: 'alexcool'
            },
            {
                startTime: 22,
                endTime: 22.99,
                title: "DJ SHALLX",
                link: 'djshallx'
            },
            {
                startTime: 23,
                endTime: 23.99,
                title: "SDEMA",
                link: 'sdema'
            },
        ],
    }
]

const data_sat = [
    {
        name: "Субота",
        events: [
            {
                startTime: 0,
                endTime: 0.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 1,
                endTime: 1.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 2,
                endTime: 2.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 3,
                endTime: 3.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 4,
                endTime: 4.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 5,
                endTime: 5.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 6,
                endTime: 6.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 7,
                endTime: 7.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 8,
                endTime: 8.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 9,
                endTime: 9.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 10,
                endTime: 10.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 11,
                endTime: 11.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 12,
                endTime: 12.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 13,
                endTime: 13.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 14,
                endTime: 14.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 15,
                endTime: 15.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 16,
                endTime: 16.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 17,
                endTime: 17.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 18,
                endTime: 18.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 19,
                endTime: 19.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 20,
                endTime: 20.99,
                title: "XANDER GUZMAN",
                link: 'xander-guzman'
            },
            {
                startTime: 21,
                endTime: 21.99,
                title: "Involver29",
                link: 'involver29',
            },
            {
                startTime: 22,
                endTime: 22.99,
                title: "Mastik Groove",
                link: 'mastik-groove',
            },
            {
                startTime: 23,
                endTime: 23.99,
                title: "Dj Tore",
                link: 'dj-tore'
            },
        ],
    }
]

const data_sun = [
    {
        name: "Неділя",
        events: [
            {
                startTime: 0,
                endTime: 0.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 1,
                endTime: 1.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 2,
                endTime: 2.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 3,
                endTime: 3.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 4,
                endTime: 4.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 5,
                endTime: 5.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 6,
                endTime: 6.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 7,
                endTime: 7.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 8,
                endTime: 8.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 9,
                endTime: 9.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 10,
                endTime: 10.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 11,
                endTime: 11.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 12,
                endTime: 12.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 13,
                endTime: 13.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 14,
                endTime: 14.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 15,
                endTime: 15.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 16,
                endTime: 16.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 17,
                endTime: 17.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 18,
                endTime: 18.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 19,
                endTime: 19.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 20,
                endTime: 20.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 21,
                endTime: 21.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 22,
                endTime: 22.99,
                title: "Free slot",
                color: 'grey',
            },
            {
                startTime: 23,
                endTime: 23.99,
                title: "Free slot",
                color: 'grey',
            },
        ],
    }
]
const data = [...data_mon, ...data_tue, ...data_wed, ...data_thu, ...data_fri, ...data_sat, ...data_sun]

function getSchedule(day) {
    switch (day) {
        case 1: return data_mon;
        case 2: return data_tue;
        case 3: return data_wed;
        case 4: return data_thu;
        case 5: return data_fri;
        case 6: return data_sat;
        case 0: return data_sun;
        default: return data;
    }
}



const theme = createTheme("google", {
    defaultTileColor: "green",
    hourHeight: "50px",
    style: {
        dayLabels: {
            fontWeight: "bold",
        },

    },

});



export { data, data_mon, data_tue, data_wed, data_thu, data_fri, data_sat, data_sun, getSchedule, theme };